<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('settings')">Settings</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> 
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('custom-reports.index')">Custom Reports</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>

    <custom-report-form
      :field-groups="fieldGroups"
    >
    </custom-report-form>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import CustomReportForm from './Partials/CustomReportForm.vue'

export default {
  metaInfo() {
    return { title: 'Create Custom Report' }
  },
  components: {
    CustomReportForm
  },
  layout: Layout,
  props: {
    fieldGroups: Array,
  },
}
</script>
